module.exports = __webpack_public_path__ + "img/10.c7b012a9.png";